export default (form) => {
    const emptyForm = form.cloneNode(true);
    form.addEventListener('reset', () => {
        form.parentNode.replaceChild(emptyForm.cloneNode(true), form);
    });
};
